import React from "react";

import AnalyticsTracking from "Utils/AnalyticsTracking";

import Button from "Cobalt/Button";
import Header from "Cobalt/Header";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import Icon from "Common/Icon";
import { SizeSwitch } from "Common/Responsive";

import makeBem from "Utils/makeBem";

const ANALYTICS_LOCATION = "paginating_up_faq_page";
const bem = makeBem("PaginatingFAQs");

const FAQModalHeader = ({ question }) => (
  <ModalHeader
    closeButton
    onClick={() => {
      AnalyticsTracking.trackEvent("modal_closed", {
        location: ANALYTICS_LOCATION,
        action: "clicked_x_icon",
      });
    }}
  >
    <Header level={7} mb={0}>
      {question}
    </Header>
  </ModalHeader>
);

const FAQModalFooter = ({ onHide, isMobile }) => (
  <ModalFooter>
    <Button
      data-dismiss
      onClick={() => {
        AnalyticsTracking.trackEvent("modal_closed", {
          location: ANALYTICS_LOCATION,
          action: isMobile ? "clicked_x_icon" : "clicked_finish_button",
        });

        onHide();
      }}
      {...(isMobile ? { color: "tertiary", className: "pull-left" } : {})}
    >
      {isMobile && <Icon icon="chevron-left" pr={3} />}
      {isMobile ? "Back" : "OK"}
    </Button>
  </ModalFooter>
);

export const FAQModal = ({ question, answer, ...props }) => (
  <SizeSwitch
    sm={
      <Modal show={props.show} {...props}>
        <FAQModalHeader question={question} />
        <ModalBody className={bem("AnswerContainer")}>{answer}</ModalBody>
        <FAQModalFooter onHide={props.onHide} isMobile={false} />
      </Modal>
    }
    xs={
      <Modal show={props.show} {...props} className="modal-fullscreen">
        <FAQModalHeader question={question} />
        <ModalBody className={bem("AnswerContainer")}>{answer}</ModalBody>
        <FAQModalFooter onHide={props.onHide} isMobile />
      </Modal>
    }
  />
);
